import { render } from "./new-account.vue?vue&type=template&id=6af4337c"
import script from "./new-account.vue?vue&type=script&lang=js"
export * from "./new-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__